import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AgentCommission`;



const ApiAgentCommission = {
  getAllAgentCommissions: (params) => {
    const url = `${baseServiceUrl}/GetAllAgentCommissions`;
    return ServiceApi.get(url, { params });
  },
  getAllAgentCommissionsBySupplierId: (params) => {
    const url = `${baseServiceUrl}/GetAllAgentCommissionsBySupplierId`;
    return ServiceApi.get(url,{ params });
  },
  getAgentCommissionById: (params) => {
    const url = `${baseServiceUrl}/GetAgentCommissionById`;
    return ServiceApi.get(url, { params });
  },
  createAgentCommission: (data) => {
    const url = `${baseServiceUrl}/CreateAgentCommission`;
    return ServiceApi.post(url, data);
  },
  editAgentCommissionItems: (data) => {
    const url = `${baseServiceUrl}/EditAgentCommissionItems`;
    return ServiceApi.post(url, data);
  },
  changeStatusAgentCommission: (data) => {
    const url = `${baseServiceUrl}/ChangeStatusAgentCommission`;
    return ServiceApi.post(url, data);
  },
};

export default ApiAgentCommission;


